// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDl9nlOfqvv87njZ7u9s4mTD9Wh6XDefK0",
  authDomain: "hiremeroy.firebaseapp.com",
  projectId: "hiremeroy",
  storageBucket: "hiremeroy.appspot.com",
  messagingSenderId: "452048716751",
  appId: "1:452048716751:web:afd5cd4383634f9fffc8ba"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app; 